import { Dropdown } from "react-bootstrap";
import { MediaBaseUrl } from "../../../../../../actions/api";
import FormComp from "../../AddFeeds/SnapUp/elements/FormComp";

const FormSettings = (props) => {
    const { title, subTitle, btnText, thankUMsg, logoImg, titleError, subTitleError, btnTextError, thankUMsgError , language, handleChange, approvePublic, setTitle, handlePopUp } = props;

    return (
       <div className="pb-scroll pe-3">
         <div className="ra-tab form-group mb-3">
            <label className='font-weight-bolder'>Form Settings</label>
          <div className="ra-formwrap flex-grow-1">
             <div className="mb-3">
                <FormComp heading={'Upload Brand Logo'} name={'logoImg'} value={logoImg} type={6} {...props} />
            </div>

             <div className="form-group mb-3">
                <label className='font-weight-bolder'>Language</label>
                <Dropdown className="select-language-main">
                    <Dropdown.Toggle className="select-language text-capitalize text-start w-100 border" variant="" id="dropdown-basic">
                        <img className="me-2 object-fit-contain" src={`${MediaBaseUrl}icons/flag-icon/${language || "english"}.svg`} width="20px" height="20px" /> {language || "English"}
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                    { ["english","french","spanish","german","arabic"].map((lang) =>{
                        return <Dropdown.Item className="text-capitalize"  onClick={() => handleChange('language',lang)}><img className="me-2 object-fit-contain" src={`${MediaBaseUrl}icons/flag-icon/${lang}.svg`} width="20px" height="20px" /> {lang}</Dropdown.Item>
                        })}
                    </Dropdown.Menu>
                </Dropdown>
            </div>

            <FormComp heading={'Title*'} error={titleError? 'This field is required.' : null} placeholder={`Share Your Moment!`} name={'title'} onTextFieldChange={setTitle} value={title} type={1} {...props} />
            <FormComp heading={'Sub Title*'} error={subTitleError? 'This field is required.' : null} placeholder={`Your review will get featured on our big screen!`} name={'subTitle'} value={subTitle} type={2} {...props} />
        
            <FormComp heading={'Submit Button Text*'} error={btnTextError ? 'This field is required.' : null} placeholder={`Get on the Wall!`} name={'btnText'} value={btnText} type={1} {...props} />
            <FormComp heading={'Thank you Message*'} error={thankUMsgError ? 'This field is required.' : null} placeholder={`Awesome! Your post is waiting for its moment to shine. Keep an eye on the wall.`} name={'thankUMsg'} value={thankUMsg} type={2} {...props} />
           
            <div className='form-group mb-3 '>
             {/* <PopupButton url="https://calendly.com/taggbox/demo" rootElement={document.getElementById("photobooth-settings")} text="Add Custom Field" className="btn btn-secondary w-100" /> */}
             <button className="btn btn-secondary w-100" onClick={() => handlePopUp(true)}>Add Custom Field</button>
            </div>

           <div className="moderate-public">
            <FormComp heading={''} name={'approvePublic'} value={approvePublic} type={5} {...props} />
         </div>
        </div>
       </div>
       </div> 
      );
    };

export default FormSettings;